<div class="p-d-flex p-flex-column gap-4 tp2Card p-p-4">
  <ng-container #fieldComponent></ng-container>
</div>
